import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import * as files from '../../../../fileUtils';
import { v4 as uuidv4 } from 'uuid';
import { date } from 'devexpress-dashboard/model/index.metadata';

export default {
  name: 'Attachments',
  components: {
    /*AttachmentComp: require('./attachment.vue').default,*/
  },
  computed: {
    isPostEditableAttachmentsActivity: function () {
      return this.$store.getters.getIsPostEditableAttachmentsActivity == true;
    },
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      attachments: [],
      editingAttachment: null,
      bConfirmDialog: false,
      deleteConfirmMessage: '',
      message: '',
      comment: ''
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_jobcard_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.dataObj.appData.attachments.forEach(p => {
          if (!p.uuid || p.uuid.length === 0)
            p.uuid = uuidv4();
        });
        this.attachments = this.dataObj.appData.attachments;
      });
    },
    processFiles(event) {
      if (event.target.files.length === 0)
        return;

      var fileNameList = [];
      var formData = new FormData();
      formData.append("objectId", this.dataObj.appData.jobcardId);
      formData.append("source", '1');
      formData.append("comment", this.comment);

      for (var i = 0; i < event.target.files.length; ++i) {
        formData.append("uploadFiles", event.target.files[i]);
        fileNameList.push(event.target.files[i].name);
      }

      axios.post('/OmActivityBase/ProcessAttachments', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.AttachmentSavedSuccess'), 2);

            for (var i = 0; i < fileNameList.length; ++i) {
              this.dataObj.appData.attachments.push({
                fileName: fileNameList[i],
                comment: this.comment,
                id: response.data.attachmentIds[i],
                stampDateTime: moment().format(),
                stampUser: response.data.userName,
                uuid: uuidv4(),
              })
            }

            this.comment = '';
          }
          else
            this.$alertMsg(response.data.data.text);
        })
        .catch(e => {
          console.log('processFiles');
          console.log(e);
          this.$alertMsg(this.$t('messages.FilesAllowed'));
        });
    },
    addAttachment() {
      var iCntrl = document.getElementById('upload');
      iCntrl.click();
    },
    removeConfirm(item) {
      this.deleteConfirmMessage = this.$t('attachments.DeleteAttachment') + ' [' + item.fileName + '] ?';
      this.editingAttachment = item;
      this.bConfirmDialog = true;
    },
    removeAttachment() {
      if (!this.editingAttachment)
        return;
      var formData = new FormData();
      formData.append("objectId", this.dataObj.appData.jobcardId);
      formData.append("source", '1');
      formData.append("deleteFiles", this.editingAttachment.id);
      axios.post('/OmActivityBase/ProcessAttachments', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.AttachmentDeletedSuccess'), 2);
            this.dataObj.appData.attachments = this.dataObj.appData.attachments.filter(p => p.uuid !== this.editingAttachment.uuid);
            this.attachments = this.dataObj.appData.attachments;
          }
          else
            this.$alertMsg(response.data.data.text);
        })
        .catch(e => {
          console.log('removeAttachment');
          console.log(e);
        });
    },
    download(id) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/OmActivityBase/DownloadAttachment', { Value: id }, { responseType: 'blob' })
        .then(files.getFile)
        .then((link) => {
          link.click();
        })
        .then(response => {
          loader.hide();
        })
        .catch((err) => {
          console.log('download');
          console.log(err);
          loader.hide();
        })
    },
    closeDialog() {
      this.bAttachmentDialog = false;
    },
  },
  
}

